'use client';

import { InputHTMLAttributes, ReactNode } from 'react';

import { useField, ErrorMessage } from 'formik';
import classnames from 'classnames';
import FormFieldError from 'app/components/common/FormFieldError';
import { useMemo } from 'react';

interface IFormFieldCheckableProps
  extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label?: ReactNode | (() => ReactNode);
  type?: 'checkbox' | 'radio';
}

export default function FormFieldCheckable({
  name,
  value,
  label,
  className,
  type = 'checkbox'
}: IFormFieldCheckableProps) {
  const [field, meta] = useField({ name, value });

  const checked = useMemo(() => {
    if (typeof field.value === 'boolean') return field.value;
    if (Array.isArray(field.value)) {
      return field.value.includes(value);
    }
    return field.value === value;
  }, [field.value, value]);

  return (
    <div className="flex flex-col gap-1">
      <label className={classnames('checkable', type, className, { checked })}>
        <i></i>
        {!!label && (
          <span>{typeof label === 'function' ? label() : label}</span>
        )}
        <input {...field} value={value} type={type} checked={checked} />
      </label>
      {typeof field.value === 'boolean' && (
        <ErrorMessage
          component={() => <FormFieldError message={meta.error} />}
          name={name}
        />
      )}
    </div>
  );
}
